import ai_loader from './ai-loader.json';
import audit_logs from './audit-logs.json';
import auth from './auth.json';
import backoffice from './backoffice.json';
import billing from './billing.json';
import card_layout from './card-layout.json';
import common from './common.json';
import contracts from './contracts.json';
import countries from './countries.json';
import custom_fields from './custom-fields.json';
import device from './device.json';
import documents from './documents.json';
import dynamic_form from './dynamic-form.json';
import error from './error.json';
import factory_operator from './factory-operator.json';
import gateways from './gateways.json';
import groups from './groups.json';
import ideaas from './ideaas.json';
import industries from './industries.json';
import integrations from './integrations.json';
import licenses from './licenses.json';
import lock from './lock.json';
import map from './map.json';
import notifications from './notifications.json';
import onboarding from './onboarding.json';
import openplc from './openplc.json';
import pages from './pages.json';
import pipelines from './pipelines.json';
import policies from './policies.json';
import project_viewer from './project-viewer.json';
import projects from './projects.json';
import rbac from './rbac.json';
import reseller from './reseller.json';
import settings from './settings.json';
import siemens_license_wizard from './siemens-license-wizard.json';
import sra from './sra.json';
import tags from './tags.json';
import ui from './ui.json';
import units from './units.json';
import vault from './vault.json';
import vulnerabilities from './vulnerabilities.json';

export const fi = {
  ai_loader,
  audit_logs,
  common,
  ideaas,
  factory_operator,
  integrations,
  siemens_license_wizard,
  dynamic_form,
  policies,
  licenses,
  auth,
  notifications,
  contracts,
  card_layout,
  documents,
  pages,
  projects,
  ui,
  tags,
  error,
  groups,
  device,
  gateways,
  project_viewer,
  rbac,
  vault,
  pipelines,
  onboarding,
  openplc,
  countries,
  industries,
  settings,
  lock,
  map,
  backoffice,
  sra,
  billing,
  units,
  vulnerabilities,
  reseller,
  custom_fields,
};
